module.exports = "/images/528124df93da0f58ddaf437bcfd825fe.svg";